<template>
  <div>
    <p>Signing in...</p>
  </div>
</template>

<script>
import AuthenticationService from "../security/AuthenticationService";

export default {
  created() {
    try {
      AuthenticationService.userManager.signinRedirectCallback().then(result => {
        var returnToUrl = "/home";
        if (result.state !== undefined) {
          returnToUrl = result.state;
        }

        this.$router.push({ path: returnToUrl });
      }).catch((e) => {
        console.log(e)
            this.$router.push({ path: "/" });
      });
    } catch (e) {
      this.$router.push({ name: "Access Denied" });
    }
  }
};
</script>
